import BloodDonationList from '@src/components/Organism/BloodDonation/BloodDonationList';
import { IBloodHome } from '@src/interfaces/blood';
import React from 'react';

type Props = {
  bloodHomeList: Array<IBloodHome>;
};

const BloodHomeTemplate = ({ bloodHomeList }: Props) => {
  return (
    <>
      <BloodDonationList bloodHomes={bloodHomeList} />
    </>
  );
};

export default BloodHomeTemplate;
